import { prefixStorageKey } from '@futrli/shared-services';

import { SIZES } from '../../../../core/constants';

export const EXPANDED_ROWS = prefixStorageKey('userGridSettings.expandedRows');
export const EDITING_ROWS = prefixStorageKey('userGridSettings.editingRows');
export const EDITING_ROW_CELLS = prefixStorageKey('userGridSettings.editingRowCells');
export const ROW_HEIGHTS = prefixStorageKey('userGridSettings.rowHeights');
export const SEEDED = prefixStorageKey('userGridSettings.seeded');
export const SHOW_DECIMALS = prefixStorageKey('userGridSettings.showDecimals');
export const SHOW_0_VALUE_ACCOUNTS = prefixStorageKey('userGridSettings.showZeroValueAccounts');

export const defaultData = {
  [EXPANDED_ROWS]: JSON.stringify([]),
  [EDITING_ROWS]: JSON.stringify([]),
  [EDITING_ROW_CELLS]: JSON.stringify({}),
  [ROW_HEIGHTS]: JSON.stringify({ default: SIZES.MEDIUM }),
  [SEEDED]: 'false',
  [SHOW_DECIMALS]: 'false',
  [SHOW_0_VALUE_ACCOUNTS]: JSON.stringify({})
};
